import axios from 'axios'
import {setUser, logoutLocal} from "../reducers/userReducer";
import config from '../config';
import { validateUsername } from '../utils/username';
import { migrateLegacyToken } from '../utils/legacyToken';
import { clearSessionMarkers } from '../utils/apiAuth';
import { telegramAutoLogin } from '../utils/telegramLogin';

let configUrl = config.apiUrl;

// Нормализация номера телефона
const normalizePhone = (phone) => {
    return String(phone).replace(/\D/g, '');
};
export const registration = (name, surname, phone, password, referrer, selectedFilial, isChecked, username) => {
    return async dispatch => {
        try {
            // Валидация на клиенте
            if (!name?.trim() || !phone?.toString().trim() || !password?.trim()) {
                alert('Пожалуйста, заполните все поля');
                return false;
            }

            const usernameError = validateUsername(username);
            if (usernameError) {
                alert(usernameError);
                return false;
            }

            const normalizedPhone = normalizePhone(phone);

            // Отправляем запрос на сервер для регистрации пользователя
            const registrationResponse = await axios.post(`${configUrl}/api/auth/registration`, {
                name,
                surname: surname?.trim() || '',
                phone: normalizedPhone,
                password,
                referrerPhone: referrer ? String(referrer).replace(/\D/g, '') : undefined,
                selectedFilial,
                isChecked,
                username: String(username).trim()
            });

            // Если регистрация прошла успешно, авторизуем пользователя
            const loginResponse = await axios.post(`${configUrl}/api/auth/login`, {
                phone: normalizedPhone,
                password
            });

            // Сессия — в httpOnly-cookie; токен из тела ответа не сохраняем
            localStorage.setItem('userId', loginResponse.data.user.id);

            // Отправляем action для обновления состояния с информацией о пользователе
            dispatch(setUser(loginResponse.data.user));

            // Возвращаем сообщение об успешной регистрации
            alert(registrationResponse.data.message);

            return true; 

        } catch (error) {
            // Обрабатываем ошибку
            alert(error.response?.data?.message || 'Не удалось зарегистрироваться. Попробуйте позже.');
            return false; 

        }
    }
}


export const login =  (phone, password) => {
    return async dispatch => {
        try {
            // Валидация на клиенте
            if (!phone?.toString().trim() || !password?.trim()) {
                alert('Пожалуйста, введите номер телефона и пароль');
                return false;
            }

            const normalizedPhone = normalizePhone(phone);

            const response = await axios.post(`${configUrl}/api/auth/login`, {
                phone: normalizedPhone,
                password
            })
            
            // Сессия — в httpOnly-cookie; токен из тела ответа не сохраняем
            localStorage.setItem('userId', response.data.user.id)
            
            // Сохраняем роль пользователя
            const isAdmin = response.data.user.role === 'admin';
            localStorage.setItem('isAdmin', isAdmin);
            
            // Обновляем состояние один раз
            dispatch(setUser(response.data.user));
            
            return true; 
            
        } catch (e) {
            const errorMsg = e.response?.data?.message || 'Ошибка авторизации';
            alert(errorMsg)
            return false; 
        }
    }
}


export const auth =  () => {
    return async dispatch => {
        try {
            // Разовая миграция старой сессии (токен в localStorage -> cookie)
            const migratedUser = await migrateLegacyToken();
            if (migratedUser) {
                dispatch(setUser(migratedUser));
            }

            // Проверка сессии по httpOnly-cookie
            const response = await axios.get(`${configUrl}/api/auth/auth`);

            // Сохраняем роль пользователя и userId
            const isAdmin = response.data.user.role === 'admin';
            localStorage.setItem('isAdmin', isAdmin);
            localStorage.setItem('userId', response.data.user.id);

            // Обновляем состояние один раз
            dispatch(setUser(response.data.user));
            console.log('✓ Авторизация восстановлена');
            return null;

        } catch (error) {
            // Сессии нет или она истекла: очищаем маркеры (без alert)
            clearSessionMarkers();
            dispatch(setUser(null));
            console.log('Авторизация потеряна, требуется повторный вход:', error.response?.status);

            // Мини-приложение Telegram: пробуем войти по initData (вне Telegram вернёт null без запросов)
            const tg = await telegramAutoLogin();
            if (tg && tg.notLinked) return tg;
            if (tg && tg.id) {
                localStorage.setItem('userId', tg.id);
                localStorage.setItem('isAdmin', tg.role === 'admin');
                dispatch(setUser(tg));
            }
            return null;
        }
    }
}

// Выход: сервер очищает cookie; ошибка сети не мешает локальному выходу
export const logout = () => {
    return async dispatch => {
        try {
            await axios.post(`${configUrl}/api/auth/logout`);
        } catch (e) {
            console.log('Не удалось уведомить сервер о выходе:', e.response?.status || e.message);
        }
        clearSessionMarkers();
        dispatch(logoutLocal());
    }
}
